import { AgentCommands, isBranchRequired, UsedCommandType } from '~/constants/commands'
import { useIsS3Task, useS3UploadedPath } from '~/hooks/task/useS3Task'
import { useRepositoryNames } from '~/hooks/useRepositoryNames'

interface TaskBlockHeaderProps {
  command: UsedCommandType
  taskId?: number
  repository?: string
  branch?: string
}

export function TaskBlockHeader({ command, taskId, branch }: TaskBlockHeaderProps) {
  const isS3STask = useIsS3Task()
  const s3UploadedPath = useS3UploadedPath()
  const repositoryNames = useRepositoryNames()

  const renderCodeContext = () => {
    if (isS3STask) {
      return s3UploadedPath ? (
        <div className='label flex items-center select-none mx-[10px] truncate'>
          <div className='label-lg-bold pr-1'>Repository: </div>
          <div className='label-lg-normal'>{s3UploadedPath.split('___').pop()}</div>
        </div>
      ) : null
    }
    return (
      <>
        <div className='label flex items-center select-none mx-[10px] truncate'>
          <div className='label-lg-bold pr-1'>Repository: </div>
          <div className='label-lg-normal'>{repositoryNames}</div>
        </div>

        {isBranchRequired(command) ? (
          <div className='label flex items-center select-none mx-[10px] truncate'>
            <div className='label-lg-bold pr-1'>Branch: </div>
            <div className='label-lg-normal'>{branch ? branch : 'No branch selected'}</div>
          </div>
        ) : null}
      </>
    )
  }

  return (
    <>
      {taskId ? (
        <div className='label flex items-center select-none mx-[10px] truncate'>
          <div className='label-lg-bold pr-1'>Task: </div>
          <div className='label-lg-normal'>
            #{taskId} -{' '}
            {command && AgentCommands[command] ? AgentCommands[command].label : 'Unknown Task'}
          </div>
        </div>
      ) : null}
      {renderCodeContext()}
    </>
  )
}
